import {observer} from 'mobx-react-lite';
import {Backdrop, CircularProgress, Theme, Typography} from '@mui/material';
import {LoadingComponentProps} from '../../../../entity/props/widget/loading-component-props';

const LoadingComponent = (props: LoadingComponentProps): JSX.Element => {
  return (
    <Backdrop open sx={(theme: Theme) => ({color: '#fff', zIndex: theme.zIndex.drawer + 1, display: 'flex', flexDirection: 'column', gap: 2})}>
      <CircularProgress id={'icon-loading'} color='inherit' />
      <Typography>{ props.title ?? 'Please Wait...' }</Typography>
    </Backdrop>
  );
}

export default observer(LoadingComponent);
